import { useEffect, useState } from 'react';

export default function useHasScrolledPast(
  elementRef: React.RefObject<HTMLElement>
) {
  const [hasScrolledPast, setHasScrolledPast] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;

      const elementLocationInView = entry.boundingClientRect.y;

      setHasScrolledPast(elementLocationInView < 0);
    });

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, [elementRef]);

  return hasScrolledPast;
}
